"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{TopNav as a}from"./src/TopNav.js";e("sp-top-nav",a);
//# sourceMappingURL=sp-top-nav.js.map
